import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

const { Option } = Select;

const OPTIONS = [
  'AA Approved',
  'RAC Approved',
  'Trust My Garage',
  'Bosch Car Service',
  'Service Sure',
  'Castrol Service Centre',
  'IMI',
  'TSI',
  'Motor Codes',
  'ATA',
  'RMI',
  'DVSA',
  'Foxy Lady Approved',
  'IGA',
  'OFT',
  'Mobil 1 service ctr',
  'IAAF',
];

export default function Accreditation({ cellValue, onFocusOut }) {
  const defaultValue = JSON.stringify(cellValue) === '{}' ? [] : JSON.parse(cellValue);
  const [value, setValue] = useState(defaultValue);
  const onChangeInput = (e) => setValue(e);

  return (
    <div>
      <Select
        mode="multiple"
        allowClear
        style={{ width: '100%' }}
        placeholder="Please select"
        defaultValue={value}
        onChange={onChangeInput}
        onBlur={onFocusOut}
      >
        {OPTIONS.map((option) => (
          <Option value={option} key={option}>
            {option}
          </Option>
        ))}
      </Select>
    </div>
  );
}

Accreditation.propTypes = {
  cellValue: PropTypes.object,
  onFocusOut: PropTypes.func,
};

Accreditation.defaultProps = {
  cellValue: {},
  onFocusOut: () => {},
};
